import { Grid2, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useMemo } from "react";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import TaskCard from "../../../components/TaskCard";
import { useStudents } from "../../../context/students";
import Students1 from "../../../assets/images/images/finance-students.jpg";
import Students2 from "../../../assets/images/images/finance-students-2.jpg";
import { useGetStudentContacts } from "../../../hooks/useGetStudentContacts";
import Preloader from "../../../components/Preloader";
import { useAuth } from "../../../auth";
import { hasPermission, PERMISSIONS } from "../../../constants/permissions";
import LockedPage from "../../../components/LockedPage";

const Finance = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const { userId } = useAuth();
    const { activeStudentId, activeStudent, permissions } = useStudents();

    const canContractsView = hasPermission(permissions, PERMISSIONS.CONTRACTS_MANAGE);
    const canFinanceView = hasPermission(permissions, PERMISSIONS.FINANCE_MANAGE);

    const { isLoading: isLoadingContact, contacts } = useGetStudentContacts(activeStudentId);

    const contact = useMemo(() => contacts.find((contact) => contact.contactId === userId) || {}, [contacts]);
    const isPrimaryContact = contact?.isPrimary;
    const isB2B = activeStudent?.isB2B;

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2} className={canContractsView || canFinanceView ? "min-head-section-height--small" : "min-head-section-height"}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("finance.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("finance.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("finance.subtitle")}
                        <a className="text-white" href={`mailto:${t("finance.emailAccounts")}`}>{t("finance.emailAccounts")}</a>
                    </Typography>
                    {canContractsView || canFinanceView ? (
                        <Typography variant="h1" component="h2" className="mt-8 text-white">
                            {t("common.quickLinks")}
                        </Typography>
                    ) : null}
                </Grid2>
                <Grid2 size={{ xs: 9, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <Preloader isLoading={isLoadingContact}>
                <LockedPage showPermissionText isLocked={!canContractsView && !canFinanceView}>
                    <Grid2 container spacing={4} className="mt-4">
                        {canFinanceView && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("finance.managePayments")}>
                                    <Typography variant="body1" component="div">
                                        {t("finance.managePaymentsText")}
                                    </Typography>
                                    <Button
                                        onClick={() => navigate(`/finance/payments/${activeStudentId}`)}
                                        className="w-full mt-4 text-base button-primary"
                                    >
                                        {t("button.viewNow")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                        {/* <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}> */}
                        {/*    <TaskCard title={t("finance.rollingRenewals")}> */}
                        {/*        <Typography variant="body1" components="div"> */}
                        {/*            {t("finance.rollingRenewalsText")} */}
                        {/*        </Typography> */}
                        {/*        <Button */}
                        {/*            onClick={() => navigate(`/finance/rollingRenewals/${activeStudentId}`)} */}
                        {/*            className="w-full mt-4 text-base button-primary" */}
                        {/*        > */}
                        {/*            {t("button.viewNow")} */}
                        {/*        </Button> */}
                        {/*    </TaskCard> */}
                        {/* </Grid2> */}
                        {(canContractsView && isPrimaryContact && !isB2B) && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("finance.manageContracts")}>
                                    <Typography variant="body1" components="div">
                                        {t("finance.manageContractsText")}
                                    </Typography>
                                    <Button
                                        onClick={() => navigate(`/finance/contracts/${activeStudentId}`)}
                                        className="w-full mt-4 text-base button-primary"
                                    >
                                        {t("button.viewNow")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                    </Grid2>
                </LockedPage>
            </Preloader>
        </div>
    );
};

export default Finance;
